module.exports = __webpack_public_path__ + "media/images/smart_phone/rank/icon_rank1-b2406d29f76ed8ffd8ead10478a641bb.png";